<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      孖岭站<br>
站点介绍<br>
孖岭站位于彩梅立交东侧的梅林路上，呈东西方向布置。南侧为青年学院、福田区委党校，北侧为深圳市福田派出所、梅林派出所，东侧为深圳市社会福利中心、残疾人康复中心。车站装修以黄色为主色调，局部门套点缀蓝色，并通过曲线造型与框架组合、局部抬高、管线遮挡等处理手法，使整个空间整体化，最大限度地改善地下封闭空间的沉闷和压抑感，为乘客创造轻松的乘车环境。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:03	23:21	9号线	3分50秒	5分55秒<br>
文锦	06:38	23:48	9号线	3分50秒	5分55秒<br>
福田口岸	06:19	23:42	10号线	3分40秒	6分钟<br>
双拥街	06:26	23:13	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:01	23:21	9号线	4分25秒	5分55秒<br>
文锦	06:38	23:48	9号线	4分25秒	5分55秒<br>
福田口岸	06:25	23:42	10号线	4分50秒	7分钟<br>
双拥街	06:34	23:13	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:05	00:21	9号线	4分钟	5分55秒<br>
文锦	06:37	00:48	9号线	4分钟	5分55秒<br>
福田口岸	06:20	00:42	10号线	4分50秒	7分钟<br>
双拥街	06:26	00:13	10号线	4分50秒	7分钟<br><br>

站点出口信息<br><br>
A2出入口:<br>
彩田路东侧（南）、深圳市革命烈士陵园<br><br>
B出入口:<br>
梅林路南侧（东）、深圳市团校、青年学院、深圳市福田区委党校、深圳开放大学、深圳市清真寺<br><br>
C出入口:<br>
梅东五路、机电大厦、鹏运大厦、福田轨道公交派出所、深圳市残疾人综合服务中心<br><br>
D出入口:<br>
彩田路东侧（北）、艺丰花园<br><br>
E出入口:<br>
梅林路南侧（西）、斯达大厦<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 青年学院<br>
B821<br><br>
C出入口:<br>
公交站名： 梅东五路<br>
B821、7<br><br>
C出入口:<br>
公交站名： 梅龙天桥<br>
M152、M202、M392、M401、M447、M448、M112、高峰专线122（原122）、高峰专线37、高快巴士27<br><br>
D出入口:<br>
公交站名： 福田党校①<br>
339、M222、M383、M398、M437、M500、高峰专线21（原201）<br>
D出入口:<br><br>
公交站名： 福田党校②<br>
34、75、339、M383、M437、高峰专线91<br><br>
D出入口:<br>
公交站名： 艺丰花园<br>
7<br><br>
E出入口:<br>
公交站名： 孖岭社康中心<br>
60、67、102、201、216、218、222、M460、N6、N9、N12<br>
  </nav>
  </template>

<script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shihaoxian",
            title: "10号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>
  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>